:host {
  display: block;
}

.pds-filters {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  gap: var(--pine-dimension-100);
}
